import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import CarrierOrderForm from './CarrierOrderForm';
import { ui } from './carrierStyles';

export default function NewCarrierOrderPage() {
  const navigate = useNavigate();
  const { orgId, isStaff, loading } = useCarrierOrg();

  if (loading) return <p style={ui.hint}>Laster…</p>;
  if (!isStaff) return <p style={ui.hint}>Bare administratorer og dispatchere kan legge inn ordre.</p>;

  return (
    <>
      <h1 style={ui.h1}>Ny ordre</h1>
      <div style={ui.card}>
        <CarrierOrderForm
          orgId={orgId}
          onSaved={(id) => navigate(`/transportor/ordre/${id}`)}
          onCancel={() => navigate('/transportor/ordre')}
        />
      </div>
    </>
  );
}
